import { Controller } from "@hotwired/stimulus"

// Unfortunately this DESY component is half-baked so we need to pull a few tricks to make it usable

// Connects to data-controller="desy-progress-indicator"
export default class extends Controller {
  static values = { urls: Array, stepLabel: String }
  static targets = ["indicator"]

  indicatorTargetConnected(target) {
    target.addEventListener("maui-focus", this.changeStep)
    target.stepProgressRenderCallback = this.renderStepProgress
  }

  indicatorTargetDisconnected(target) {
    target.removeEventListener("maui-focus", this.changeStep)
  }

  renderStepProgress = (currentStep, stepsCount) => {
    return `${this.stepLabelValue} ${currentStep} / ${stepsCount}`
  }

  changeStep = () => {
    const step = this.indicatorTarget.currentStep
    const originalStep = parseInt(this.indicatorTarget.getAttribute("currentstep"))
    if (step === originalStep) return
    const url = this.urlsValue[step]
    if (url) Turbo.visit(url)
  }
}
